module.exports = __webpack_public_path__ + "media/newstyle/images/icon-header-aila-editor-f0cd46dfc79340d927d2cb566b9d3d0b.svg";